import { ITheme } from "../../utils/theme";

export const tableHeaderStyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold',
  marginBottom: 0.5,
}

export const collapsibleFrameStyles = (theme: ITheme) => ({
  marginTop: 4,
  marginBottom: 1,
  '& svg.arrowDropIcon': {
    fill: theme.palette.blue[600],
  }
});

export const footerStyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold',
  marginTop: 4,
  marginBottom: 2,
}
